module.exports = __webpack_public_path__ + "img/honer6.f01ebc13.jpg";